import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import dialogCommon from 'Theme/DialogCommon.jss';

const baseStyles = {
    ...dialogCommon
};

export default StyleSheet.create(baseStyles);
